/* eslint-disable max-len */
/* eslint-disable no-console */
import { API } from 'aws-amplify';
import {
	UPDATE_CREATION_FEATURES,
	UpdateCreationFeaturesPayload,
	CreationFeatures
} from './types';

// API endpoint name as configured in index.tsx
const API_NAME = 'revisedResources';

/**
 * Update the creation features
 * @param companyId - Company identifier
 * @param payload - Object containing the updated creation features
 * @returns The updated creation features configuration
 */
export const updateCreationFeatures = async (
	companyId: string,
	payload: UpdateCreationFeaturesPayload
): Promise<{ creationFeatures: CreationFeatures }> =>
{
	try
	{
		const response = await API.patch(
			API_NAME,
			`/configurations/${companyId}/creation-features`,
			{
				body : payload
			}
		);

		// Return the updated configuration
		if (response?.data?.creationFeatures)
		{
			return {
				creationFeatures : response.data.creationFeatures
			};
		}

		// If no creationFeatures in response, return what we sent
		// This handles edge cases where the API doesn't return the updated data
		return {
			creationFeatures : payload
		};
	}
	catch (error)
	{
		console.error('Error updating creation features:', error);
		throw error;
	}
};